"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromReadableAmount = fromReadableAmount;

var _ethers = require("ethers");

var READABLE_FORM_LEN = 4;

function fromReadableAmount(amount, decimals) {
  return _ethers.ethers.utils.parseUnits(amount.toString(), decimals);
} // export function toReadableAmount(rawAmount, decimals) {
//   return ethers.utils
//     .formatUnits(rawAmount, decimals)
//     .slice(0, READABLE_FORM_LEN)
// }